/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <div class="main_top">
      <h3 class="headerTitle">招标单列表</h3>
      <div class="search">
        <el-input
          v-model="waitpayValue"
          placeholder="请输入订单号"
          class="ipt"
        ></el-input>
        <button class="btn" @click="searchHandle()">查询</button>
      </div>
    </div>

    <el-tabs
      type="border-card"
      class="tabs"
      v-model="activeName"
      @tab-click="tabhandleClick"
    >
      <el-tab-pane name="0" label="全部">
        <span slot="label"
          >全部<i>({{ formcount.all }})</i>
        </span>
      </el-tab-pane>
      <el-tab-pane name="1" label="待确认">
        <span slot="label"
          >待确认<i>({{ formcount.confirming }})</i>
        </span>
      </el-tab-pane>
      <el-tab-pane name="2" label="待发货">
        <span slot="label"
          >待发货<i>({{ formcount.waitDelivery }})</i>
        </span>
      </el-tab-pane>
      <el-tab-pane name="3" label="待收货">
        <span slot="label"
          >待收货<i>({{ formcount.waitReceiving }})</i>
        </span>
      </el-tab-pane>
      <el-tab-pane name="4" label="订单完成">
        <span slot="label"
          >订单完成<i>({{ formcount.done }})</i>
        </span>
      </el-tab-pane>
    </el-tabs>
    <el-row>
      <div class="tab_pane_content" v-loading="loading">
        <div class="search_box"></div>
        <el-table
          :header-cell-style="headClass"
          :data="orderInfoList"
          style="width: 100%"
        >
          <el-table-column
            prop="orderNumber"
            label="订单"
            width="200px"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="amount" label="订单金额" align="center">
          </el-table-column>
          <el-table-column prop="amount" label="实付金额" align="center">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="下单日期"
            width="150px"
            align="center"
          >
          </el-table-column>
           <el-table-column
           v-if="formInline.status=='3'"
            prop="deliveryTime"
            label="发货时间"
            width="150px"
            align="center"
          >
        
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">{{
              convertOrderStatus(scope.row.status)
            }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180px">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="pricebtn"
                @click="handleDetail(scope.row, scope.$index)"
              >
                查看详情
              </el-button>
              <el-button
                v-if="activeName == 3"
                type="text"
                style="color: #c65442"
                @click="handleConfirm(scope.row, scope.$index)"
              >
                确认收货
              </el-button>
              <el-button
                v-if="activeName == 0 && scope.row.status == 3"
                type="text"
                style="color: #c65442"
                @click="handleConfirm(scope.row, scope.$index)"
              >
                确认收货
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-row>
      <el-col :span="24" class="pagination">
        <!-- 分页组件 -->
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { Supplierorderlist, confirmharvest, myordercount } from "@/api/xunyou";
export default {
  data() {
    return {
      loading: true,
      activeName: 0,
      orderInfoList: [],
      waitpayValue: "",
      // 请求数据参数
      formInline: {
        userId: JSON.parse(localStorage.getItem("userdata")).userId,
        pageSize: 10,
        pageNum: 1,
        status: "",
        orderNumber: "",
      },
      // 分页参数
      pageparm: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      formcount: {
        all: "", //全部
        confirming: "",
        waitReceiving: "",
        waitDelivery: "",
        done: "",
      },
    };
  },
  // 注册组件
  components: { Pagination },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.handleData();
    this.handlecount();
  },
  mounted() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询数量
    handlecount() {
      myordercount({ userId: this.formInline.userId }).then((res) => {
        this.formcount = res.data;
      });
    },

    //查询数据
    handleData() {
      Supplierorderlist(this.formInline).then((res) => {
        // console.log(res, "res数据");
        this.loading = false;
        this.orderInfoList = res.rows;
        this.pageparm.total = res.total;
      });
    },
    // ,分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.handleData();
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //   切换tab
    tabhandleClick(tab, event) {
    
      this.formInline.status = this.orderStatus(Number(tab.index));
      this.formInline.orderNumber = this.waitpayValue;
      this.handleData();
      
    },

    // 搜索功能
    searchHandle() {
      this.formInline.status = this.orderStatus(Number(this.activeName));
      this.formInline.orderNumber = this.waitpayValue;
      this.handleData();
    },

    //订单状态，1-待确认，2-待发货，3-待收货，4-订单完成，不传查所有
    orderStatus(status) {
      switch (status) {
        case 0:
          return "";
          break;
        default:
          return status;
      }
    },
    //订单状态，1-待确认，2-待发货，3-待收货，4-订单完成，不传查所有
    convertOrderStatus(status) {
      switch (status) {
        case 1:
          return "待确认";
          break;
        case 2:
          return "待发货";
          break;
        case 3:
          return "待收货";
          break;
        case 4:
          return "完成";
          break;
        default:
          return "--";
      }
    },
    handleDetail(item, index) {
    
      
      this.$router.push(
        `/PurchaseOrderDetails?id=${item.id}&status=${item.status}`
      );
      // console.log("xiangq");
    },
    //确认收获
    handleConfirm(item) {
      confirmharvest({ oid: item.id })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "确认收货成功!",
            });
            this.handleData();
             this.handlecount();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("确认收货失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.main_top {
  display: flex;
  justify-content: space-between;
  border-bottom: 2.5px dotted #e3e3e3;
  padding-bottom: 20px;

  .search {
    display: flex;
    .ipt {
      outline: none;
    }
    .btn {
      color: white;
      font-size: 14px;
      border: none;
      border-radius: 0 4px 4px 0;
      width: 80px;
      height: 40px;
      line-height: 20px;
      background-color: #c65442;
      padding: 10px;
    }
  }
}
.tabs {
  margin-top: 20px;
}
// .rightaside{
//     background: white;
//     margin-left: 15px;
//     padding: 20px !important;
.rightaside_content {
  .headerTitle {
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #c65442 !important;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }
  .search_box {
    text-align: right;
    margin-bottom: 10px;
    .input-with-select.el-input.el-input-group.el-input-group--append {
      width: 40%;
    }
  }
  .redBorder {
    border: 1px solid #ff6700 !important;
  }
  .orderbox_info {
    // padding: 20px;
    // box-sizing: border-box;
    margin-bottom: 10px;
    border: 1px solid#ccc;
    .orderbox_info_header {
      padding: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      p {
        font-size: 16px;
        color: #ff6700;
        margin-bottom: 5px;
      }
      .order_money i {
        font-size: 20px;
        color: #ff6700;
      }
    }
    .order_goods_whole {
      padding: 20px;
      box-sizing: border-box;
      .order_goods {
        margin-bottom: 20px;
        .order_Info_item {
          margin-left: 20px;
        }
      }
      button.el-button.buttonStyle {
        padding: 6px 30px;
        font-size: 12px;
        margin-bottom: 6px;
        margin-left: 0;
      }
      .dangerBg.buttonStyle {
        background-color: #ff6700;
        border-color: #ff6700;
      }
      .el-button--danger.is-plain {
        background: white;
      }
      .el-button--danger:focus,
      .el-button--danger:hover {
        color: white;
        background: #f56c6c;
      }
    }
  }
  .tab_pane_content {
    .noData {
      text-align: center;
      height: 200px;
      line-height: 200px;
    }
  }
}
// }
.pagination {
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #fff;
    width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next,
  /deep/.el-pagination.is-background .btn-prev,
  /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/mypurchaseRight.vue